module.exports = __webpack_public_path__ + "static/img/Ethan-Strange.02951d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ethan-Strange.jpg
// module id = xPXh
// module chunks = 0